<ng-template #buttonbar>
	<stages-buttons-bottom [removeBoundaries]="true">
		<stages-button
			[disabled]="!isSaveEnabled()"
			(clicked)="cancel()"
			[title]="'cancel'"
			[buttonClasses]="'button sm cancel'"
		/>
		<stages-button
			[disabled]="!isSaveEnabled()"
			(clicked)="save()"
			[buttonType]="'submit'"
			[buttonClasses]="'button sm save'"
			[title]="'save'"
			[showLoadingSpin]="isLoading"
		/>
	</stages-buttons-bottom>
</ng-template>

<div
	class="description-overflow-container"
	[ngClass]="{ 'edit-off': !editorActive, collapsed: !expanded, expanded: expanded, alreadyLoaded: !firstLoad }"
>
	<div #descriptionSlideContainer [@expandCollapseFromTop]="animationParams">
		<article class="description module" [ngClass]="{ invisible: firstLoad && !expanded }">
			@if (!editorActive && isEmpty()) {
				<p class="empty" translate="none"></p>
			}
			@if (!editorActive) {
				<stages-description-view
					[descriptionId]="descriptionId"
					[html]="displayDescription.html"
				></stages-description-view>
			}
			@if (editorActive && renderedDescription !== undefined) {
				<div>
					<ng-container *ngTemplateOutlet="buttonbar"></ng-container>
					<div class="description-spacing">
						<stages-description-editor
							[editorId]="editorId"
							[modifiable]="modifiable"
							[unsafe]="false"
							[description]="$any(renderedDescription)"
							[processTypeIdent]="$any(processTypeIdent())"
							[pluginRegistry]="pluginRegistry"
							[beanType]="beanType()"
							[beanId]="beanId()"
							[beanIdentity]="beanIdentity()"
							[workspaceId]="workspaceId()"
							[pv]="pv()"
							[properties]="properties()"
						>
						</stages-description-editor>
					</div>
					<ng-container *ngTemplateOutlet="buttonbar"></ng-container>
				</div>
			}
		</article>
	</div>
</div>
